import { render, staticRenderFns } from "./StackItem.vue?vue&type=template&id=0b6a1886&"
import script from "./StackItem.vue?vue&type=script&lang=js&"
export * from "./StackItem.vue?vue&type=script&lang=js&"
import style0 from "./StackItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem})
